import { Component } from '@angular/core';
import { BaseComponent } from '../base-component/base.component';

@Component({
  selector: 'favie-header',
  templateUrl: './header.component.html',
})
export class HeaderComponent extends BaseComponent {}
